import http, { getData } from '@/api/http';
import type { ApprovalTemplate, Status } from '@/types/approvalTemplate';

const resource = 'approval-templates';

export interface ListParams {
  page?: number; // 1-based 输入
  size?: number; // 每页数量
  keyword?: string; // 关键字
  status?: Status; // ACTIVE | INACTIVE
}

export const approvalTemplateService = {
  async list(): Promise<ApprovalTemplate[]> {
    try {
      const resp = await http.get(`/api/${resource}`);
      return getData<ApprovalTemplate[]>(resp) as ApprovalTemplate[];
    } catch {
      return [];
    }
  },
  async update(id: number, payload: ApprovalTemplate): Promise<ApprovalTemplate | null> {
    try {
      const resp = await http.put(`/api/${resource}/${id}`, payload);
      return getData<ApprovalTemplate>(resp) as ApprovalTemplate;
    } catch {
      return null;
    }
  },
};

export type ApprovalTemplateService = typeof approvalTemplateService;
